import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../../../account/account.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TransferenciaService } from '../transferencia.service';
import { TransferenciaModel } from '../transferencia.model';
import { AuthService } from '../../../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-transferencia',
  templateUrl: './transferencia.component.html',
  styleUrls: ['./transferencia.component.scss'],
})
export class TransferenciaComponent {
  saque = new FormGroup({
    tipoChave: new FormControl<string>('', Validators.required),
    chavePix: new FormControl<string>('', Validators.required),
    chavePixCpfCnpj: new FormControl<string>('', [Validators.required]),
    chavePixEmail: new FormControl<string>('', [
      Validators.required,
      Validators.email,
    ]),
    valorSolicitado: new FormControl<number | null>(null, [
      Validators.required,
      Validators.min(10),
    ]),
    taxa: new FormControl<number>(0),
    valorTotal: new FormControl<number>(0),
    documentoRecebedor: new FormControl<string>('', Validators.required),
  });

  public tiposChavePix = [
    { id: 'CPF', value: 'CPF' },
    { id: 'CNPJ', value: 'CNPJ' },
    { id: 'EMAIL', value: 'E-mail' },
    { id: 'PHONE', value: 'Celular' },
    { id: 'EVP', value: 'Aleatória (EVP)' },
  ];
  public saldoDisponivel: string = '';
  public withDrawTaxValue: number = 0;
  public withDrawTaxPercent: number = 0;

  public placeholderValue: string;
  public documentoMask: string = '00000000000'; 

  public isSubmitted: boolean;
  public chavePixFeedBack: string;
  public valorFeedBack: string;
  public documentoFeedBack: string;
  public tipoChaveFeedBack: string;

  public isLoaded: boolean = true;
  public openConfirm: boolean;
  public errorMessage: string;
  public validationCode: string;
  public dictResponse: any;
  public validatingTotp: boolean = false;


  @ViewChild('requestTOTPCode') validateToken: ElementRef | any;
  @ViewChild('txtChavePix', { static: false })
  txtChavePix!: ElementRef<HTMLInputElement>;

  constructor(
    private accountService: AccountService,
    private transferenceService: TransferenciaService,
    private authService: AuthService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.getAccountValues();
    this.isSubmitted = false;
    this.chavePixFeedBack = '';
    this.valorFeedBack = '';
    this.documentoFeedBack = '';
    this.tipoChaveFeedBack = '';
    this.placeholderValue = '';
    this.errorMessage = '';
    this.validationCode = '';
    this.openConfirm = false;
  }

  getAccountValues() {
    this.accountService.getAccount().then((value) => {
      this.saldoDisponivel = value.readyAmount;
      this.withDrawTaxValue = value.withdrawTaxValue;
      this.withDrawTaxPercent = value.withdrawTaxPercent;
      this.getPlaceHolder();
    });
  }

  getPlaceHolder() {
    let valorDisponivel = Number(this.saldoDisponivel);
    let placeholderValue =
      (valorDisponivel - this.withDrawTaxValue) /
      (1 + this.withDrawTaxPercent / 100);

    if (placeholderValue < 0) placeholderValue = 0;

    this.placeholderValue = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(placeholderValue);
  }

  async pastePixKey(): Promise<void> {
  if (this.openConfirm) return;

  const tipo = this.saque.controls.tipoChave.value;
  if (!tipo) return;

  try {
    let clip = (await navigator.clipboard.readText()).trim();

    if (tipo === 'CPF' || tipo === 'CNPJ' || tipo === 'PHONE') {
      clip = clip.replace(/\D/g, '');
    }

    const ctrl =
      (tipo === 'CPF' || tipo === 'CNPJ') ? this.saque.controls.chavePixCpfCnpj :
      (tipo === 'EMAIL')                  ? this.saque.controls.chavePixEmail   :
                                            this.saque.controls.chavePix;

    ctrl.setValue(clip);
    ctrl.markAsDirty();
    ctrl.updateValueAndValidity();   
  } catch (err) {
    console.error('Erro ao colar chave Pix:', err);
  }
}

  async pasteDocument(): Promise<void> {
  try {
    const digits = (await navigator.clipboard.readText())
                     .replace(/\D/g, '')
                     .trim();

    const ctrl = this.saque.controls.documentoRecebedor;
    ctrl.setValue(digits);
    ctrl.markAsDirty();
    ctrl.updateValueAndValidity();
  } catch (err) {
    console.error('Erro ao colar documento:', err);
  }
}


  valorSolicitadoChanged() {
    let valor = Number(
      Number(this.saque.controls.valorSolicitado.value).toFixed(2)
    );
    let taxa = (valor * this.withDrawTaxPercent) / 100;
    taxa = Number(taxa.toFixed(2)) + this.withDrawTaxValue;
    let valorTotal = valor > 0 ? valor + taxa : 0;
    this.saque.controls.taxa.setValue(taxa);
    this.saque.controls.valorTotal.setValue(valorTotal);
  }

  openDataConfirm() {
    this.isSubmitted = true;
    this.isLoaded = false;
  
    if (!this.formIsValid()) {
      this.isLoaded = true;
      return;
    }
    
  
    this.transferenceService
    .searchDICT(this.getChavePix(), this.saque.controls.tipoChave.value!)
    .then((value) => {
      this.dictResponse = value;
      this.isLoaded = true;

      if (this.dictResponse.isValidated) {
        this.makeWithdraw();
      } else {
        this.openConfirm = true;
      }
    })
    .catch((error) => {
      this.toastr.error(error.error.mensagem || 'Erro ao consultar DICT.', 'Erro', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
    });
  }

  async pasteTotpCode(): Promise<void> {
  try {
    this.validationCode = (await navigator.clipboard.readText()).trim();
  } catch (err) {
    console.error('Erro ao colar o código:', err);
  }
}

  makeWithdraw() {
    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.modalService.open(this.validateToken, {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'sm',
    });
  }
  
  public ajustarErrosChavePix() {
    if (
      this.saque.controls.tipoChave.value === 'CPF' ||
      this.saque.controls.tipoChave.value === 'CNPJ'
    ) {
      this.saque.controls.chavePix.setErrors(null);
      this.saque.controls.chavePixEmail.setErrors(null);
    } else if (this.saque.controls.tipoChave.value === 'EMAIL') {
      this.saque.controls.chavePixCpfCnpj.setErrors(null);
      this.saque.controls.chavePix.setErrors(null);
    } else {
      this.saque.controls.chavePixCpfCnpj.setErrors(null);
      this.saque.controls.chavePixEmail.setErrors(null);
    }
  }

  public getChavePix(): string {
    if (
      this.saque.controls.tipoChave.value === 'CPF' ||
      this.saque.controls.tipoChave.value === 'CNPJ'
    ) {
      return this.saque.controls.chavePixCpfCnpj.value!;
    } else if (this.saque.controls.tipoChave.value === 'EMAIL') {
      return this.saque.controls.chavePixEmail.value!;
    } else {
      return this.saque.controls.chavePix.value!;
    }
  }

  public clearForm() {
    this.saque.reset();
    this.accountService.getAccount().then((value) => {
      this.saldoDisponivel = value.readyAmount;
      this.withDrawTaxValue = value.withdrawTaxValue;
      this.withDrawTaxPercent = value.withdrawTaxPercent;
      this.getPlaceHolder();
      this.isSubmitted = false;
      this.openConfirm = false;
    });
  }

  public formIsValid(): boolean {
    this.ajustarErrosChavePix();

    if (this.saque.controls.valorSolicitado.hasError('min')) {
      this.valorFeedBack = 'Valor inválido - Valor mínimo R$ 10,00!';
    } else if (this.saque.controls.valorSolicitado.invalid) {
      this.valorFeedBack = 'Valor é obrigatório!';
    }

    if (this.saque.controls.tipoChave.hasError('required')) {
      this.tipoChaveFeedBack = 'Tipo chave obrigatória!';
    }

    if (
      this.saque.controls.tipoChave.value === 'CPF' ||
      this.saque.controls.tipoChave.value === 'CNPJ'
    ) {
      if (this.saque.controls.chavePixCpfCnpj.hasError('required')) {
        this.chavePixFeedBack = 'Chave pix obrigatória!';
      } else if (
        (this.saque.controls.chavePixCpfCnpj.value?.length === 11 &&
          !cpf.isValid(this.saque.controls.chavePixCpfCnpj.value)) ||
        (this.saque.controls.chavePixCpfCnpj.value?.length === 14 &&
          !cnpj.isValid(this.saque.controls.chavePixCpfCnpj.value))
      ) {
        this.saque.controls.chavePixCpfCnpj.setErrors(Validators.required);
        this.chavePixFeedBack = 'Chave pix inválida (CPF / CNPJ)!';
      }
    } else if (this.saque.controls.tipoChave.value === 'EMAIL') {
      if (this.saque.controls.chavePixEmail.hasError('required')) {
        this.chavePixFeedBack = 'Chave pix obrigatória!';
      } else if (this.saque.controls.chavePixEmail.invalid) {
        this.chavePixFeedBack = 'Chave pix inválida (E-mail)!';
      }
    } else {
      if (this.saque.controls.chavePix.invalid) {
        this.chavePixFeedBack = 'Chave pix obrigatória!';
      }
    }

    if(this.saque.controls.documentoRecebedor.value!.length === 11 && !cpf.isValid(this.saque.controls.documentoRecebedor.value!) ||
       this.saque.controls.documentoRecebedor.value!.length === 14 && !cnpj.isValid(this.saque.controls.documentoRecebedor.value!))
    {
      this.saque.controls.documentoRecebedor.setErrors(Validators.required)
      this.documentoFeedBack = 'Documento inválido!';
    }
    if(this.saque.controls.documentoRecebedor.hasError('required')){
      this.documentoFeedBack = 'Documento é obrigatório!';
    }

    return this.saque.valid;
  }

  async validateTotp() {

    if (this.validatingTotp) {           
      return;
    }
    
    this.validatingTotp = true;

    this.isLoaded = false;

    if (await this.isValidTotp()) {
      this.modalService.dismissAll();
      let transferModel = new TransferenciaModel();
      transferModel.person.pixKeyTypes = this.saque.controls.tipoChave.value!;
      transferModel.person.pixKey = this.getChavePix();
      transferModel.value = this.saque.controls.valorSolicitado.value!;
      transferModel.endToEndId = this.dictResponse.endToEndId;
      transferModel.person.name = this.dictResponse.nomeProprietario;
      transferModel.person.cpf = this.saque.controls.documentoRecebedor.value!;
      firstValueFrom(this.transferenceService.sendWithdraw(transferModel))
        .then((value) => {

          if(value.isSend)
          {
            this.toastr.success(
              `Solicitação de saque realizada com sucesso! Transação: ${value.id}`,
              'Sucesso',
              {
                timeOut: 3000,
                positionClass: 'toast-center-center',
              }
            );
          }
          else
          {
            this.toastr.warning(
              `Solicitação de saque em analise!`,
              'Alerta',
              {
                timeOut: 3000,
                positionClass: 'toast-center-center',
              }
            );

          }
          this.validatingTotp = false;
          this.clearForm();
          this.isLoaded = true;
        })
        .catch((error) => {
          this.toastr.error(error.error.mensagem, 'Erro', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.isLoaded = true;
          this.validatingTotp = false;
        });
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
      this.validatingTotp = false;

    }
  }

  async isValidTotp() {
    let isValid: boolean = false;
    await this.authService
      .validateTotpCode(this.validationCode)
      .then((value) => {
        isValid = value.isValid;
      });
    return isValid;
  }
}
